import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { createTerms, fetchTermById, fetchTerms, updateTerms } from "../../service/api";

export const getTerms = createAsyncThunk(
    "terms/getAll",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchTerms(params)
            console.log("privacy", response)
            return response.data

        } catch (error) {
            return rejectWithValue(err.response.data || err.message)
        }
    }
)


export const getTermsById = createAsyncThunk(
    "terms/byId",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchTermById(params)
            console.log("terms by id", response)
            return response.data

        } catch (error) {
            return rejectWithValue(err.response.data || err.message)
        }
    }
)


export const addTerms = createAsyncThunk(
    "terms/add",
    async (params, { rejectWithValue }) => {

        try {
            const response = await createTerms(params)
            console.log("privacy", response)

        } catch (error) {
            return rejectWithValue(err.response.data || err.message)
        }
    }
)

export const editTerms = createAsyncThunk(
    "terms/edit",
    async (params, { rejectWithValue }) => {

        try {
            const response = await updateTerms(params)
            console.log("response", response)

        } catch (error) {
            return rejectWithValue(err.response.data || err.message)
        }
    }
)


const termSlice = createSlice({
    name: "terms",
    initialState: {
        termsList: [],
        termsById: {},
        isLoading: false,
        actionLoader: false,
        error: null,

    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getTerms.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getTerms.fulfilled, (state, action) => {
                state.isLoading = false,
                    state.termsList = action.payload.data
                state.totalPage = action.payload.totalPages
            })
            .addCase(getTerms.rejected, (state) => {
                state.isLoading = true,
                    state.error = null
            })

            //term by id 

            .addCase(getTermsById.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getTermsById.fulfilled, (state, action) => {
                state.isLoading = false,
                    state.termsById = action.payload.data
                state.totalPage = action.payload.totalPages
            })
            .addCase(getTermsById.rejected, (state) => {
                state.isLoading = true,
                    state.error = null
            })

            //Post 

            .addCase(addTerms.pending, (state) => {
                state.actionLoader = true
            })
            .addCase(addTerms.fulfilled, (state, action) => {
                state.actionLoader = false

            })
            .addCase(addTerms.rejected, (state) => {
                state.actionLoader = false
            })

            //put 

            .addCase(editTerms.pending, (state) => {
                state.actionLoader = true
            })
            .addCase(editTerms.fulfilled, (state, action) => {
                state.actionLoader = false

            })
            .addCase(editTerms.rejected, (state) => {
                state.actionLoader = false
            })


    }
})

export default termSlice.reducer